import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import _ from 'underscore';
import DatePicker from 'react-datepicker';
import moment from 'moment';

import { acAxiosRequest } from '../actions/acAxiosRequest';
import { acPopVizibil } from '../actions/acPopVizibil';
import { acConSizeChange } from '../actions/acConSizeChange';

// import { stat } from 'fs';
class PopIstoricPariuri extends React.Component {

    constructor() {
        super();
        this.state = {
            status: 'All',
            loteria: 'All',
            pag: 0,
            startDate: moment(),
            endDate: moment(),
            height: null,
        }
    }
    componentDidMount() {
        var axios = {
            ruta: this.props.appProps.ruta,
            request: 'get_user_history',
            reducer: 'ISTORIC_PARIURI',
            value: 'start=' + this.state.startDate.format('YYYY/MM/DD') + '&finish=' + this.state.endDate.format('YYYY/MM/DD') + '&lottery_name=All&status=All&page=1',
            extra: 'pariuri',
            error: '4000',
            newParam: this.props.sessionParam
        }
        this.props.acAxiosRequest(axios)
    }
    componentDidUpdate() {
        if (this.refPopBH && this.state.height === null) {
            if (this.props.conSizeChange && this.props.conSizeChange.colMid < this.refPopBH.offsetHeight) {
                this.setState({ height: this.refPopBH.offsetHeight + 120 })
                this.props.acConSizeChange({ colMid: this.refPopBH.offsetHeight + 120 })
            }
        }
    }
    sendFiltre(val) {
        var key = Object.keys(val);
        // var v = Object.values(val);
        var v = Object.keys(val).map(function (e) {
            return val[e]
        })
        var filtre = {
            lottery: this.state.loteria,
            status: this.state.status,
            pag: this.state.pag,
            startDate: this.state.startDate.format('YYYY/MM/DD'),
            endDate: this.state.endDate.format('YYYY/MM/DD'),
            [key]: v[0]
        }
        if (this.props.istoricPariuri.extra === 'pariuri') {
            var nrpag = parseInt(filtre.pag, 10) + 1;
            var axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_user_history',
                reducer: 'ISTORIC_PARIURI',
                value: 'start=' + filtre.startDate + '&finish=' + filtre.endDate + '&lottery_name=' + filtre.lottery.replace(/ /g, "_") + '&status=' + filtre.status + '&page=' + nrpag + '',
                extra: 'pariuri',
                error: '4001',
                newParam: this.props.sessionParam
            }
        }
        if (this.props.istoricPariuri.extra === 'runde') {
            axios = {
                ruta: this.props.appProps.ruta,
                request: 'get_rounds',
                reducer: 'ISTORIC_PARIURI',
                value: 'lottery_name=' + this.props.activeLot.name_lot.replace(/ /g, "_") + '&type=1&next_page=' + filtre.pag + '',
                extra: 'runde',
                error: '3210',
                newParam: this.props.sessionParam
            }
        }
        this.props.acAxiosRequest(axios);
    }
    closePop() {
        this.props.acPopVizibil([false, null]);
    }
    popHead() {
        return <div className="popup-title"><span>{this.props.multiLang.istoricBilete.txt}</span><span onClick={this.closePop.bind(this)}>X</span></div>
    }
    handleChangeStart(date) {
        this.setState({
            startDate: date
        });
        this.sendFiltre({ 'startDate': date.format("YYYY/MM/DD") });
    }
    handleChangeEnd(date) {
        this.setState({
            endDate: date
        });
        this.sendFiltre({ 'endDate': date.format("YYYY/MM/DD") });
    }
    lotFiltru(e) {
        this.setState({ loteria: e.target.value.replace(/ /g, "_") });
        this.sendFiltre({ lottery: e.target.value.replace(/ /g, "_") });
    }
    statusFiltru(e) {
        this.setState({ status: e.target.value });
        this.sendFiltre({ status: e.target.value });
    }
    filtre() {
        return (
            <div className="popup-filtre">
                <div className="filtru date-picker">
                    <div className="date-picker-item">
                        <span className="date-picker-label">{this.props.multiLang.startDate.txt}</span>
                        <DatePicker
                            selected={this.state.startDate}
                            selectsStart startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleChangeStart.bind(this)} />
                    </div>
                    <div className="date-picker-item">
                        <span className="date-picker-label">{this.props.multiLang.endDate.txt}</span>
                        <DatePicker
                            selected={this.state.endDate}
                            selectsEnd startDate={this.state.startDate}
                            endDate={this.state.endDate}
                            onChange={this.handleChangeEnd.bind(this)} />
                    </div>
                </div>
                <div className="filtru">
                    <span>{this.props.multiLang.loteria.txt}</span>
                    <select value={this.state.lotereia} onChange={this.lotFiltru.bind(this)}>
                        <option key={0} value="All">{this.props.multiLang.all.txt}</option>
                        {
                            this.props.loterii.map((val, i) => {
                                return <option key={val.name_lot} value={val.name_lot}>{val.name_lot}</option>
                            })
                        }

                    </select>
                </div>
                <div className="filtru">
                    <span>{this.props.multiLang.status.txt}</span>
                    <select value={this.state.status} onChange={this.statusFiltru.bind(this)}>
                        <option value="All">{this.props.multiLang.all.txt}</option>
                        <option value="Pending">{this.props.multiLang.pending.txt}</option>
                        <option value="Paidout">{this.props.multiLang.castigator.txt}</option>
                        <option value="Lost">{this.props.multiLang.pierdut.txt}</option>
                        <option value="Return">{this.props.multiLang.returnBet.txt}</option>
                        <option value="Canceled">{this.props.multiLang.anulat.txt}</option>
                    </select>
                </div>
            </div>
        )
    }
    formatDate(el) {

        let dateArr = el.split(" ");
        let day = dateArr[0];
        let dayShort = day.split("-");
        let dayShortRet = dayShort[2] + "/" + dayShort[1];
        let time = dateArr[1];
        let timeShort = time.split(":");
        let timeShortRet = timeShort[0] + ":" + timeShort[1];
        return (<span>{dayShortRet}<br />{timeShortRet}</span>)
    }
    popBody() {

        var header = [
            <tr key={'filtre'}>
                <th>{this.props.multiLang.loteria.txt}</th>
                <th>{this.props.multiLang.runda.txt}</th>
                <th>{this.props.multiLang.dataJucata.txt}</th>
                <th>{this.props.multiLang.nb2.txt}</th>
                <th>{this.props.multiLang.systems.txt}</th>
                <th>{this.props.multiLang.stake.txt}</th>
                <th>{this.props.multiLang.castig.txt}</th>
                <th>{this.props.multiLang.status.txt}</th>
                <th>{this.props.multiLang.ticketId.txt}</th>
            </tr>
        ]
        //NEW PROMO NEW CLIENTS
        //     promotions = [
        //     {
        //         "id": 1,
        //         "promotion_name": "newClients",
        //         "start_time": "2020-03-09 00:00:00",
        //         "end_time": "2020-03-31 00:00:00"
        //     }
        // ]

        var body = this.props.istoricPariuri.response.tickets.map((val, i) => {
            if (val.promo && val.promo[0] && parseInt(val.promo[0]) === 6) {
                var promoClass = " newClients_green"
            }
            if (val.status_code === 21) {
                var statusDiac = this.props.multiLang.castigator.txt,
                    borderClass = " b_green"
            } else if (val.status_code === 22) {
                statusDiac = this.props.multiLang.pierdut.txt
                borderClass = " b_red"
            } else if (val.status_code === 24) {
                statusDiac = this.props.multiLang.pending.txt
                borderClass = " b_orange"
            } else if (val.status_code === 23) {
                statusDiac = this.props.multiLang.returnBet.txt
                borderClass = " b_light_green"
            } else if (val.status_code === 25) {
                statusDiac = this.props.multiLang.anulat.txt
                borderClass = " b_red_light"
            } else {
                statusDiac = val.status
            }
            return (
                <tr className={borderClass + ' ' + promoClass} key={i}>
                    <td className={borderClass}>{val.lottery_name}</td>
                    <td>{this.formatDate(val.round_time)}</td>
                    <td>{this.formatDate(val.ticket_time)}</td>
                    <td>{this.checkWinNr(val)}</td>
                    <td>{val.game_systems}</td>
                    <td>{val.money_in}</td>
                    <td>{val.money_out}
                        {this.winArrayDetailed(val.win_array.split(','))}
                    </td>
                    <td>{statusDiac}</td>
                    <td className={borderClass}>{val.ticketid}</td>
                </tr>)
        });
        body = header.concat(body);

        return body
    }
    checkWinNr(val) {
        var arr = []
        var nr = val.numbers.split(',')
        var nrw = 0
        if (val.numbers_won !== null) {
            nrw = val.numbers_won.split(',')
        }
        for (let i = 0; i < nr.length; i++) {
            if (_.contains(nrw, nr[i])) {
                arr.push(<span key={nr[i]} className="bold">{nr[i]}{this._comma(i, nr.length)}</span>)
            }
            else {
                arr.push(<span key={nr[i]}>{nr[i]}{this._comma(i, nr.length)}</span>)
            }

        }
        return arr
    }
    _comma(i, l) {
        if (i + 1 === l) { return '' } else { return ', ' }
    }
    castigPosibil(sum) {
        var bool = false;

        for (var i = 0; i < sum.length; i++) {
            if (sum[i] !== 0) {
                bool = true;
            }
        }

        if (bool === true) {
            return (<th colSpan="2">{this.props.multiLang.possWin2.txt}</th>)
        }
    }
    winArrayDetailed(sum) {
        return (
            <div id="win-array-cont">
                <img className="img-win-array-detailed" id="info-img" src="img/icon/info-black.png" alt="" />
                <div className="win-array-detailed">
                    <table>
                        <thead>
                            <tr>
                                {this.castigPosibil(sum)}
                            </tr>
                        </thead>
                        <tbody>
                            {sum.map((val, i) => {
                                if (val !== 0) {
                                    return (
                                        <tr key={i}>
                                            <td>
                                                {i + 1}  {(i + 1 !== 1) ? this.props.multiLang.nb2.txt : this.props.multiLang.nb.txt}
                                            </td>
                                            <td>
                                                {val}
                                            </td>
                                        </tr>
                                    )
                                } return true
                            })}
                        </tbody>
                    </table>
                </div>
            </div>
        )
    }
    pagChange(val) {
        var pagInc = 0
        if (val === 'inc') {
            pagInc = this.state.pag + 1
        }
        else if (val === 'dec') {
            pagInc = this.state.pag - 1
        }
        if (pagInc < 0) {
            pagInc = 0;
        }
        this.setState({ pag: pagInc });
        this.sendFiltre({ pag: pagInc });
    }
    disabledButInc() {
        this.disabledButDec()
        if ((this.props.istoricPariuri.response.length < 30) || ((this.props.istoricPariuri.response.tickets) && (this.props.istoricPariuri.response.tickets.length < 30))) {
            return true
        } else {
            return false
        }
    }
    disabledButDec() {
        if (this.state.pag === 0) {
            return true
        } else {
            return false
        }
    }
    render() {
        if (this.props.istoricPariuri) {
            // console.log('this.props.istoricPariuri', this.props.istoricPariuri.response.promotions[0].promotion_name === 'newClients');
            return (
                <div ref={(f) => this.refPopBH = f} className="popUp-Content pariuri">

                    <div className="runde-child">
                        {this.popHead()}
                        {this.filtre()}
                        <table>
                            <tbody>
                                {this.popBody()}
                            </tbody>
                        </table>
                        {this.props.istoricPariuri.response && this.props.istoricPariuri.response.promotions && this.props.istoricPariuri.response.promotions[0] && this.props.istoricPariuri.response.promotions[0].id === 6 ?
                            <div className="status_info promo">
                                <div>
                                    {this.props.istoricPariuri.response.promotions[0].promotion_name}
                                    {/* <span className="period">{' ' + moment(this.props.istoricPariuri.response.promotions[0].start_time).format('DD-MM') + '/' + moment(this.props.istoricPariuri.response.promotions[0].end_time).format('DD-MM')}</span> */}
                                </div>
                            </div> : null}
                        <div className="status_info">
                            <div className="color">
                                <span className="bullet red"></span>
                                <span className="txt">{this.props.multiLang.pierdut.txt}</span>
                            </div>
                            <div className="color">
                                <span className="bullet green"></span>
                                <span className="txt">{this.props.multiLang.castigator.txt}</span>
                            </div>
                            <div className="color">
                                <span className="bullet orange"></span>
                                <span className="txt">{this.props.multiLang.pending.txt}</span>
                            </div>
                            <div className="color">
                                <span className="bullet light_green"></span>
                                <span className="txt">{this.props.multiLang.returnBet.txt}</span>
                            </div>
                            <div className="color">
                                <span className="bullet light_red"></span>
                                <span className="txt">{this.props.multiLang.anulat.txt}</span>
                            </div>
                        </div>
                        <div className="pagination">
                            <button onClick={this.pagChange.bind(this, 'dec')} disabled={this.disabledButDec()}></button>
                            <button onClick={this.pagChange.bind(this, 'inc')} disabled={this.disabledButInc()}></button>
                        </div>
                    </div>
                </div>
            )
        } else {
            return <div></div>
        }
    }
}
function mapStateToProps(state) {
    return {
        appProps: state.appProps,
        popVizibil: state.popVizibil,
        multiLang: state.multiLang,
        istoricPariuri: state.istoricPariuri,
        loterii: state.loterii,
        sessionParam: state.sessionParam,
        conSizeChange: state.conSizeChange
    }
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        acAxiosRequest: acAxiosRequest,
        acPopVizibil: acPopVizibil,
        acConSizeChange: acConSizeChange
    }, dispatch)
}
export default connect(mapStateToProps, matchDispatchToProps)(PopIstoricPariuri);